import { PointExpression } from 'leaflet';

export const createClusterIconHtml = (
  path: string,
  clusterSize: number,
  size: PointExpression,
) => {
  return `
        <div style="
          position: relative;
          width: ${size}px;
          height: ${size}px;
          display: flex;
          align-items: center;
          justify-content: center;
        ">
          <img src="assets/leaflet/images/point-icons/${path}.svg"
            style="width: 100%; height: 100%; object-fit: contain;"/>
          <div style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 12px;
            padding: 2px 5px;
            border-radius: 50%;
          ">${clusterSize}</div>
        </div>
      `;
};
